import type { LoadableType } from '@confluence/loadable';
import { LoadablePaint } from '@confluence/loadable';

export const ConnectSpaceCustomContentListView: LoadableType<{
	spaceKey: string;
	type: string;
}> = LoadablePaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-srcConnectSpaceCustomContentListView" */ '../src/ConnectSpaceCustomContentListView.tsx'
			)
		).ConnectSpaceCustomContentListView,
});
